import { Flex } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { textStyleKeys, textStyles } from '@mangovoice/design-system'

import { OverallSentimentStatus } from './OverallSentimentStatus'

interface OverallSentimentSectionProps {
  overallCustomerScore: number
  overallAgentScore: number
  marginTop?: string
}

export const OverallSentimentSection = ({
  overallCustomerScore,
  overallAgentScore,
  marginTop,
}: OverallSentimentSectionProps) => {
  const { t } = useTranslation()

  return (
    <Flex
      flexDirection="column"
      gap="0.625rem"
      marginTop={marginTop}
      width="full"
    >
      <Flex color="fg.default" {...textStyles[textStyleKeys.Body1_Bold]}>
        {t('callDetails.sentiment.title')}
      </Flex>
      <Flex gap="1.75rem">
        <OverallSentimentStatus
          overallSentimentScore={overallCustomerScore}
          personType={t('callDetails.sentiment.patient')}
        />
        <OverallSentimentStatus
          overallSentimentScore={overallAgentScore}
          personType={t('callDetails.sentiment.office')}
        />
      </Flex>
    </Flex>
  )
}
